function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { observable, makeObservable } from "mobx";
import ImageryProvider from "terriajs-cesium/Source/Scene/ImageryProvider";
import isDefined from "../Core/isDefined";
import { scaleDenominatorToLevel } from "../Core/scaleToDenominator";
import CommonStrata from "./../Models/Definition/CommonStrata";
function MinMaxLevelMixin(Base) {
  var _class, _descriptor;
  let MinMaxLevelMixin = (_class = class MinMaxLevelMixin extends Base {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "notVisible", _descriptor, this);
      makeObservable(this);
    }
    get supportsMinMaxLevel() {
      return true;
    }
    getMinimumLevel(ows) {
      return scaleDenominatorToLevel(this.maxScaleDenominator, true, ows);
    }
    getMaximumLevel(ows) {
      return scaleDenominatorToLevel(this.minScaleDenominator, false, ows);
    }
    static updateRequestImageInternal(mixin, imageryProvider, minimumLevel, maximumLevel, hideLayerAfterMinScaleDenominator) {
      const realRequestImage = imageryProvider.requestImage;
      if (isDefined(maximumLevel) && hideLayerAfterMinScaleDenominator || isDefined(minimumLevel)) {
        // TODO: The cast is necessary because the type Cesium declares for
        // `requestImage` is incorrect. It is missing `CompressedTextureBuffer`
        // as a possible return type.

        imageryProvider.requestImage = (x, y, level, _request) => {
          if (maximumLevel && level > maximumLevel || minimumLevel && level < minimumLevel) {
            if (isDefined(imageryProvider.enablePickFeatures)) {
              imageryProvider.enablePickFeatures = false;
            }
            if (maximumLevel && level > maximumLevel && mixin.hideLayerAfterMinScaleDenominator) {
              mixin.setTrait(CommonStrata.defaults, "scaleWorkbenchInfo", "translate#models.scaleDatasetNotVisible.scaleZoomOut");
            } else if (minimumLevel && level < minimumLevel) {
              mixin.setTrait(CommonStrata.defaults, "scaleWorkbenchInfo", "translate#models.scaleDatasetNotVisible.scaleZoomIn");
            }
            return ImageryProvider.loadImage(imageryProvider, "".concat(mixin.terria.baseUrl, "images/blank.png"));
          }
          mixin.setTrait(CommonStrata.defaults, "scaleWorkbenchInfo", undefined);
          if (isDefined(imageryProvider.enablePickFeatures)) {
            imageryProvider.enablePickFeatures = true;
          }
          return realRequestImage.call(imageryProvider, x, y, level);
        };
      }
      return imageryProvider;
    }
    updateRequestImage(imageryProvider) {
      let ows = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      const maximumLevel = this.getMaximumLevel(ows);
      const minimumLevel = this.getMinimumLevel(ows);
      const hideLayerAfterMinScaleDenominator = this.hideLayerAfterMinScaleDenominator;
      return MinMaxLevelMixin.updateRequestImageInternal(this, imageryProvider, minimumLevel, maximumLevel, hideLayerAfterMinScaleDenominator);
    }
    updateRequestImageAsync(imageryProviderPromise) {
      let ows = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      const maximumLevel = this.getMaximumLevel(ows);
      const minimumLevel = this.getMinimumLevel(ows);
      const hideLayerAfterMinScaleDenominator = this.hideLayerAfterMinScaleDenominator;
      return imageryProviderPromise.then(imageryProvider => {
        return MinMaxLevelMixin.updateRequestImageInternal(this, imageryProvider, minimumLevel, maximumLevel, hideLayerAfterMinScaleDenominator);
      });
    }
  }, _descriptor = _applyDecoratedDescriptor(_class.prototype, "notVisible", [observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _class);
  return MinMaxLevelMixin;
}
(function (_MinMaxLevelMixin2) {
  function isMixedInto(model) {
    return model && model.supportsMinMaxLevel;
  }
  _MinMaxLevelMixin2.isMixedInto = isMixedInto;
})(MinMaxLevelMixin || (MinMaxLevelMixin = {}));
export default MinMaxLevelMixin;